export const SliderItems = [
    { url: null, image:'/images/bob-banner-2.jpg'},
    { url: null, image:'/images/bob-banner.jpg'}
]
